var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonStory.jinja');
require('./CommonStory.less');

var CommonStoryText = require('front/components/CommonStory/CommonStoryText');
var CommonStoryColumns = require('front/components/CommonStory/CommonStoryColumns');
var CommonStoryImage = require('front/components/CommonStory/CommonStoryImage');
var CommonStoryQuote = require('front/components/CommonStory/CommonStoryQuote');
var CommonStoryGallery = require('front/components/CommonStory/CommonStoryGallery');
var CommonStoryVideo = require('front/components/CommonStory/CommonStoryVideo');
var CommonStoryMembers = require('front/components/CommonStory/CommonStoryMembers');
var CommonStoryBanner = require('front/components/CommonStory/CommonStoryBanner');
var CommonStoryButton = require('front/components/CommonStory/CommonStoryButton');
var CommonStoryDownloads = require('front/components/CommonStory/CommonStoryDownloads');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonStoryText': {selector: '.CommonStoryText', viewConstructor: CommonStoryText},
        'CommonStoryColumns': {selector: '.CommonStoryColumns', viewConstructor: CommonStoryColumns},
        'CommonStoryImage': {selector: '.CommonStoryImage', viewConstructor: CommonStoryImage},
        'CommonStoryQuote': {selector: '.CommonStoryQuote', viewConstructor: CommonStoryQuote},
        'CommonStoryGallery': {selector: '.CommonStoryGallery', viewConstructor: CommonStoryGallery},
        'CommonStoryVideo': {selector: '.CommonStoryVideo', viewConstructor: CommonStoryVideo},
        'CommonStoryMembers': {selector: '.CommonStoryMembers', viewConstructor: CommonStoryMembers},
        'CommonStoryBanner': {selector: '.CommonStoryBanner', viewConstructor: CommonStoryBanner},
        'CommonStoryButton': {selector: '.CommonStoryButton', viewConstructor: CommonStoryButton},
        'CommonStoryDownloads': {selector: '.CommonStoryDownloads', viewConstructor: CommonStoryDownloads}
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStory.js
// module id = 26
// module chunks = 0